import React from 'react';

import {
  Container,
  DatePicker,
  LabelDivider
} from './styles';

export default function RangeDatePicker() {
  return (
    <Container>
      <DatePicker type="date" />
      <LabelDivider>à</LabelDivider>
      <DatePicker type="date" />
    </Container>
  );
}